export const getNumberOfItems = (
  registerMember,
  registerTicket,
  hideNewPassword
) => {
  let items = 0;
  if (registerMember) {
    items = items + 1;
  }
  if (registerTicket) {
    items = items + 1;
  }
  if (!hideNewPassword) {
    items = items + 1;
  }
  return items;
};
